module.exports = __webpack_public_path__ + "static/media/fremantle.c59f7334.svg";